import type { SiteListingMode } from '@starkey/shared'

export function getSiteListingCopy(mode: SiteListingMode) {
  if (mode === 'SPONSOR') {
    return {
      catalogEyebrow: 'Support',
      catalogTitle: '赞助',
      catalogLead: '选择你希望支持的项目，进入详情后挑选档位并完成记录。',
      detailBackLabel: '返回赞助',
      homePrimaryLabel: '前往赞助',
    }
  }

  return {
    catalogEyebrow: 'Products',
    catalogTitle: '商品列表',
    catalogLead: '选择你需要的商品，进入详情后挑选规格并完成记录。',
    detailBackLabel: '返回商品列表',
    homePrimaryLabel: '商品列表',
  }
}
